import { SvgIconType } from './svg.interface';

const Pill: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#6A7383'
}) => (
  <div>
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.10445 5.55328L5.55328 1.10445C6.26235 0.397185 7.22297 0 8.22447 0C9.22597 0 10.1866 0.397185 10.8957 1.10445C12.3681 2.57691 12.3681 4.96807 10.8957 6.44682L6.44682 10.8957C4.96807 12.3681 2.57691 12.3681 1.10445 10.8957C0.397185 10.1866 0 9.22597 0 8.22447C0 7.22297 0.397185 6.26235 1.10445 5.55328ZM1.99799 6.44682C1.68415 6.75784 1.45826 7.14642 1.34332 7.57306C1.22837 7.99969 1.22845 8.44916 1.34357 8.87575L5.1128 5.1128L7.78085 7.78085L10.0021 5.55328C10.2369 5.32057 10.4232 5.04366 10.5503 4.73856C10.6775 4.43345 10.7429 4.10618 10.7429 3.77564C10.7429 3.44509 10.6775 3.11783 10.5503 2.81272C10.4232 2.50761 10.2369 2.23071 10.0021 1.99799C9.7694 1.76325 9.4925 1.57693 9.18739 1.44978C8.88228 1.32263 8.55501 1.25716 8.22447 1.25716C7.89393 1.25716 7.56666 1.32263 7.26155 1.44978C6.95644 1.57693 6.67954 1.76325 6.44682 1.99799L1.99799 6.44682Z"
        fill={color}
      />
    </svg>
  </div>
);

export default Pill;
